import { render } from "./HomeCrm.vue?vue&type=template&id=d16f2788&ts=true"
import script from "./HomeCrm.vue?vue&type=script&lang=ts"
export * from "./HomeCrm.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__